import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import ErrorBoundary from './components/ErrorBoundary';
import TrackingPageAppWithUrl from './containers/TrackingPageAppWithUrl';
import TrackingPageApp from './containers/TrackingPageApp';
import configureStore from './store/configureStore.prod';

function renderTrackingPage(elementId) {
  const store = configureStore();

  render(
    <ErrorBoundary>
      <Provider store={store}>
        <TrackingPageAppWithUrl pathname={window.location.pathname}>
          {({ trackingPageId, orderId, zipCode }) => (
            <TrackingPageApp trackingPageId={trackingPageId} orderId={orderId} zipCode={zipCode} />
          )}
        </TrackingPageAppWithUrl>
      </Provider>
    </ErrorBoundary>,
    document.getElementById(elementId)
  );
}

export default renderTrackingPage;
